export default __webpack_public_path__ + "static/media/chair-with-no-back.860fd130.webp";